import React, { useState } from "react";
import "../../index.css";
import "../../App.css";
import { Row, Col, Tag, Typography } from "antd";
import { painEntryFormConstants } from "../../helpers/painEntryFormConstants";
import { useSelector, useDispatch } from "react-redux";
import { RootState, AppDispatch } from "./../../redux-toolkit/store/store";
import { handleTriggerChange } from "../../redux-toolkit/slices/painEntryFormSlice";

const triggerTrackingOptions: string[] =
  painEntryFormConstants.triggerTrackingOptions;

const TeTriggerTracking = () => {
  const checkedTriggers = useSelector(
    (state: RootState) => state.painEntryForm.triggerTracking
  );

  const dispatch = useDispatch();
  return (
    <div className="flex flex-col gap-2">
      <label className="h6 text-theme-text-secondary">
        <strong>Trigger Tracking *</strong>
      </label>
      <p className="body1 text-theme-text-primary mb-4">
        Select any triggers that may have caused or worsened your pain.
      </p>
      <Row gutter={[10, 20]}>
        {triggerTrackingOptions.map((trigger) => (
          <Col
            key={trigger}
            xl={6}
            xxl={6}
            lg={6}
            md={8}
            sm={12}
            xs={12}
            style={{ display: "flex" }}
          >
            <Tag.CheckableTag
              checked={checkedTriggers.includes(trigger)}
              onChange={() => dispatch(handleTriggerChange(trigger))}
              className="checkable-tag-pain-entry"
            >
              {trigger}
            </Tag.CheckableTag>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default TeTriggerTracking;
